import { ChildrenElement } from "tm/utils";

export type Job = {
  company: string;
  ctaHref: string;
  ctaTarget: string;
  ctaTitle: string;
  featured: string | null;
  imgAlt: string | null;
  imgSrc: string | null;
  location: string;
  position: string;
  salary: string;
  time: string;
  type: string;
};

export default class extends ChildrenElement<Job> {
  childTagName = "TM-JOB-ITEM";
  extractor = (element: Element) => {
    return {
      company: element.getAttribute("company")!,
      ctaHref: element.getAttribute("cta-href")!,
      ctaTarget: element.getAttribute("cta-target") || "",
      ctaTitle: element.getAttribute("cta-title")!,
      featured: element.getAttribute("featured"),
      imgAlt: element.getAttribute("img-alt"),
      imgSrc: element.getAttribute("img-src"),
      location: element.getAttribute("location")!,
      position: element.getAttribute("position")!,
      salary: element.getAttribute("salary")!,
      time: element.getAttribute("time")!,
      type: element.getAttribute("type")!,
    };
  };

  private get jobs() {
    let showImage = this.items.every((item) => item.imgSrc);
    return this.items.map((item, index) =>
      // HACK: For some reason, using the spread operator causes Chromatic break
      Object.assign({}, item, {
        className: `card card-base ${item.featured ? "featured" : ""}`,
        imgSrc: showImage ? item.imgSrc : undefined,
        key: `${item.position}_${index}`,
      })
    );
  }
}
